/**
 * IOSInstallPrompt — install hint for iOS Safari users.
 *
 * iOS Safari does not support beforeinstallprompt, so there is no native install
 * button (that path is handled on Android/Chrome by usePWA().install()). Instead
 * we show a dismissible hint telling iOS users to tap Share → Add to Home Screen.
 *
 * Only renders on real iOS Safari when the app is NOT already installed
 * (showIOSInstall from usePWA). Dismissal lasts the session.
 *
 * Wire into App.jsx: <IOSInstallPrompt />
 */
import { usePWA } from '@/hooks/usePWA'

export default function IOSInstallPrompt() {
  const { showIOSInstall, dismissIOSInstall } = usePWA()

  if (!showIOSInstall) return null

  return (
    <div
      role="dialog"
      aria-label="Install Tony's Liquor"
      style={{
        position: 'fixed',
        bottom: '80px', // above bottom nav, same as PWAUpdatePrompt
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        background: '#1a1a1a',
        border: '1px solid #0e947a',
        borderRadius: '12px',
        padding: '0.75rem 1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        boxShadow: '0 4px 24px rgba(0,0,0,0.5)',
        minWidth: '280px',
        maxWidth: '92vw',
      }}
    >
      <span style={{ fontSize: '1.4rem', lineHeight: 1 }}>📲</span>
      <div style={{ flex: 1 }}>
        <p style={{ margin: 0, fontSize: '0.85rem', fontWeight: 600, color: '#f0f0f0' }}>
          Install Tony&apos;s Liquor
        </p>
        <p style={{ margin: 0, fontSize: '0.75rem', color: '#aaa', lineHeight: 1.4 }}>
          Tap{' '}
          <span
            aria-hidden="true"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              verticalAlign: '-2px',
            }}
          >
            {/* iOS Share glyph (square with an up arrow) */}
            <svg width="13" height="15" viewBox="0 0 20 24" fill="none"
                 xmlns="http://www.w3.org/2000/svg" style={{ margin: '0 2px' }}>
              <path d="M10 1L6 5M10 1L14 5M10 1V15" stroke="#0eb98f"
                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5 9H3.5A1.5 1.5 0 002 10.5V21A1.5 1.5 0 003.5 22.5h13A1.5 1.5 0 0018 21V10.5A1.5 1.5 0 0016.5 9H15"
                    stroke="#0eb98f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
          {' '}Share, then <strong style={{ color: '#f0f0f0' }}>Add to Home Screen</strong>.
        </p>
      </div>
      <button
        onClick={dismissIOSInstall}
        aria-label="Dismiss"
        style={{
          background: 'transparent',
          color: '#888',
          border: 'none',
          fontSize: '1.3rem',
          lineHeight: 1,
          cursor: 'pointer',
          padding: '0 0.15rem',
          whiteSpace: 'nowrap',
        }}
      >
        ×
      </button>
    </div>
  )
}
